import React, { useEffect, useState, useContext } from "react";
import "./RamlNazar.css";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { ramlKey } from "../../data";
// import Header from '../../components/header/Header'
import HeaderB from "../../components/headerb/HeaderB";
import { Link } from "react-router-dom";
import { MainContext } from "../../contexts/MainContext";
import NatijehLink from "../../utils/NatijehLink";

export default function RamlCircle1() {
  let { zayech } = useContext(MainContext);
  const [ramlKeys, setRamlKeys] = useState(ramlKey);
  const mainContext = useContext(MainContext);
  console.log(zayech);
  return (
    <>
      <Container fluid>
        <HeaderB />
      </Container>

      <Container>
        <Row>
          <Col xs={11} md={6}>
            <div>
              <>
                <div>
                  <br />
                  <br />
                  <br />
                  {zayech?.length == 0 ? (
                    <>
                      <div className="ramlcircle-loading ">
                        <div class="loading">
                          <div class="loading_circle"></div>
                          <div class="loading_circle"></div>
                          <div class="loading_circle"></div>
                        </div>
                        <h1 className="ramlcircle-div2">درحال لود شدن</h1>
                      </div>
                    </>
                  ) : (
                    <div className="divNazar1">
                      <div>
                        <>
                          {zayech?.length != 0 && (
                            //   && mainContext.flag !== false
                            <Col className="divNazar2">
                              <Image thumbnail style={{ border: "none" }} src="./images/pagePishrafte/chartRangi3.png" alt="" />
                              {zayech?.map((item, index) => (
                                <>
                                  <span key={index} className={`khane${index + 1}`}>
                                    <div className="ramldivN">
                                      <img className="ramlnazar" src={item.src} alt="" />
                                    </div>
                                  </span>
                                </>
                              ))}

                              <span className="moqarene1-2">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>
                              <span className="moqarene2-3">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>
                              <span className="moqarene3-4">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>
                              <span className="moqarene4-5">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>
                              <span className="moqarene5-6">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>
                              <span className="moqarene6-7">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>
                              <span className="moqarene7-8">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>
                              <span className="moqarene8-9">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>
                              <span className="moqarene9-10">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>
                              <span className="moqarene10-11">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>
                              <span className="moqarene11-12">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>
                              <span className="moqarene12-13">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>
                              <span className="moqarene13-14">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>
                              <span className="moqarene14-15">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>
                              <span className="moqarene15-16">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>
                              <span className="moqarene16-1">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqarene.png" alt="" />
                                </div>
                              </span>

                              <span className="tasdis1-3">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>
                              <span className="tasdis2-4">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>
                              <span className="tasdis3-5">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>
                              <span className="tasdis4-6">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>
                              <span className="tasdis5-7">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>
                              <span className="tasdis6-8">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>
                              <span className="tasdis7-9">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>
                              <span className="tasdis8-10">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>
                              <span className="tasdis9-11">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>
                              <span className="tasdis10-12">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>
                              <span className="tasdis11-13">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>
                              <span className="tasdis12-14">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>
                              <span className="tasdis13-15">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>
                              <span className="tasdis14-16">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>
                              <span className="tasdis15-1">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>
                              <span className="tasdis16-2">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tasdis.png" alt="" />
                                </div>
                              </span>

                              <span className="tarbi1-4">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>
                              <span className="tarbi2-5">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>
                              <span className="tarbi3-6">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>
                              <span className="tarbi4-7">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>
                              <span className="tarbi5-8">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>
                              <span className="tarbi6-9">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>
                              <span className="tarbi7-10">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>
                              <span className="tarbi8-11">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>
                              <span className="tarbi9-12">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>
                              <span className="tarbi10-13">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>
                              <span className="tarbi11-14">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>
                              <span className="tarbi12-15">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>
                              <span className="tarbi13-16">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>
                              <span className="tarbi14-1">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>
                              <span className="tarbi15-2">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>
                              <span className="tarbi16-3">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tarbi.png" alt="" />
                                </div>
                              </span>

                              <span className="tathlith1-5">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>
                              <span className="tathlith2-6">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>
                              <span className="tathlith3-7">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>
                              <span className="tathlith4-8">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>
                              <span className="tathlith5-9">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>
                              <span className="tathlith6-10">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>
                              <span className="tathlith7-11">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>
                              <span className="tathlith8-12">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>
                              <span className="tathlith9-13">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>
                              <span className="tathlith10-14">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>
                              <span className="tathlith11-15">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>
                              <span className="tathlith12-16">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>
                              <span className="tathlith13-1">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>
                              <span className="tathlith14-2">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>
                              <span className="tathlith15-3">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>
                              <span className="tathlith16-4">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/tathlith.png" alt="" />
                                </div>
                              </span>

                              <span className="moqable1-7">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                              <span className="moqable2-8">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                              <span className="moqable3-9">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                              <span className="moqable4-10">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                              <span className="moqable5-11">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                              <span className="moqable6-12">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                              <span className="moqable7-13">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                              <span className="moqable8-14">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                              <span className="moqable9-15">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                              <span className="moqable10-16">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                              <span className="moqable11-1">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                              <span className="moqable12-2">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                              <span className="moqable13-3">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                              <span className="moqable14-4">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                              <span className="moqable15-5">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                              <span className="moqable16-6">
                                <div className="ramldivN">
                                  <img className="ramlnazar" src="./images/nazarat/moqable.png" alt="" />
                                </div>
                              </span>
                            </Col>
                          )}
                        </>
                      </div>
                    </div>
                  )}
                </div>
              </>
            </div>
          </Col>

          <Col xs={12} md={2}>
            {" "}
          </Col>

          <Col xs={10} md={4}>
            <div center className="d-grid gap-2 divBtn">
              <br />
              <br />

              <Link className="linkBtn" to="/ramlcircle">
                {" "}
                زایچه دوار{" "}
              </Link>
              <Link className="linkBtn" to="/ramlpic">
                {" "}
                زایچه درختواره{" "}
              </Link>
              <Link className="linkBtn" to="/RamlJadval">
                قـوت و ضـعـف
              </Link>
              <NatijehLink style={true} />
              <br />
              <br />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
